import type { EntryMeta } from '~/types'
import Gallery from '~/components/gallery/Gallery'
import type { MediaPath } from '~/generated/media'

const cover = 'thailand/phuket_rooftop.jpg' satisfies MediaPath
const a = 'projects/rockets4.jpg' satisfies MediaPath
// TODO: replace placeholder images with real 2025 photos

export const meta: EntryMeta = {
	slug: '2025',
	name: '2025',
	excerpt: 'Selected frames',
	tags: ['photography'],
	cover,
	order: 100,
}

export default function Year2025() {
	return (
		<>
			<p>A year in frames.</p>
			<Gallery
				items={[
					{ src: cover, alt: '2025' },
					{ src: a, alt: '2025' },
				]}
			/>
		</>
	)
}
